/**
 * Course Box Overlay (dnd-kit Migration)
 * Visual representation during drag
 */
import { memo } from 'react';
import clsx from 'clsx';
import styles from './CourseBoxOverlay.module.css';
import { getCourseColor } from '../utils/courseColor';

const CourseBoxOverlay = memo(({ course }) => {
    if (!course) return null;

    const { code, section, room, isVirtual } = course;
    const colorClass = `color${getCourseColor(code)}`;

    const roomShort = (room || 'TBA')
        .replace(/, Lift [0-9]+((-|,)( )*[0-9]+)?/gi, '')
        .replace(/\([0-9]+\)/gi, '')
        .replace(/Lecture Theater /gi, 'LT')
        .replace(/, [A-Z ]+/gi, '');

    return (
        <div className={clsx('lesson', styles.overlay, colorClass, { [styles.virtual]: isVirtual })}>
            <div>
                {code}<br />
                {section}<br />
                {roomShort}
            </div>
        </div>
    );
});

CourseBoxOverlay.displayName = 'CourseBoxOverlay';

export default CourseBoxOverlay;
